import { useContext } from 'react';
import { AuthContext, type StaffRole, type StaffProfile } from './AuthProvider';

export type { StaffRole, StaffProfile };

/**
 * Auth-Hook für Sizilianer-Backoffice.
 *
 * **Wichtig:** Liest aus AuthContext (siehe AuthProvider.tsx). Der Provider
 * muss in App.tsx (oder weiter oben) gemountet sein.
 *
 * Vorteil: kein erneuter `getSession()` / `loadProfile()` bei jedem
 * Component-Mount (vorher: Lade-Loop bei Nav-Wechsel).
 *
 * API ist rückwärts-kompatibel zur alten Hook-Version — alle bestehenden
 * Consumer (~13 Files) funktionieren weiter ohne Änderung.
 */
export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) {
    throw new Error(
      'useAuth() muss innerhalb eines <AuthProvider>-Tree aufgerufen werden. ' +
        'Stelle sicher, dass AuthProvider in src/App.tsx gemountet ist.',
    );
  }
  return ctx;
}
